module.exports = __webpack_public_path__ + "img/SIRIGABB.14d90032.png";